import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";
import { SERVICES, IMG } from "@/data/content";

export default function Diensten() {
  useSeo({
    title: "Diensten | Imperium Group — alle vormen van marketing",
    description: "Ontdek het complete dienstenaanbod van Imperium Group: digitale marketing, SEO & SEA, social media, contentmarketing, telemarketing, leadgeneratie, branding, websites & funnels, e-mailmarketing, TV, radio, billboard & OOH en sportsponsoring.",
    path: "/diensten",
  });

  return (
    <div data-testid="diensten-page">
      <PageHero
        overline="Diensten"
        title="Het complete marketingspectrum"
        subtitle="Van digitaal tot op straat, van beeld tot geluid. Imperium Group biedt echt álles op het gebied van marketing — in elke combinatie die jouw merk nodig heeft."
        image={IMG.analytics}
      />

      <section className="pb-8">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-6 sm:grid-cols-2 lg:grid-cols-3 lg:px-10">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.slug} delay={(i % 3) * 0.06}>
                <div className="group flex h-full flex-col rounded-2xl border border-white/10 bg-[#12151D] p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#FF4500]/50" data-testid={`dienst-${s.slug}`}>
                  <span className="flex h-13 w-13 items-center justify-center rounded-xl bg-[#FF4500]/10 p-3 text-[#FF4500]"><Icon className="h-6 w-6" /></span>
                  <div className="mt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#00E599]">{s.tag}</div>
                  <h3 className="mt-2 font-display text-xl font-semibold text-white">{s.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                  <Link to="/offerte" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#FF4500]">Vraag offerte aan <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></Link>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-20">
        <div className="mx-auto max-w-5xl px-6 lg:px-10">
          <Reveal>
            <div className="rounded-3xl border border-white/10 bg-[#12151D] p-10 lg:p-14">
              <h2 className="font-display text-2xl font-bold text-white lg:text-3xl">Alles combineerbaar tot één 360°-campagne</h2>
              <p className="mt-4 text-base leading-relaxed text-slate-400">Je kiest één dienst of een complete multichannel-aanpak. Wij stemmen boodschap, creatie en kanalen perfect op elkaar af.</p>
              <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {["Online én offline marketing", "Creatie, media-inkoop en executie in huis", "Eén strategie, één aanspreekpunt", "Sturen op leads, conversie en ROI"].map((t) => (
                  <div key={t} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#00E599]/15 text-[#00E599]"><Check className="h-3.5 w-3.5" /></span>
                    <span className="text-sm text-slate-300">{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
